export default __webpack_public_path__ + "static/media/check.278e3e6d.png";